package meineglasfaser.frontend.common.components.widgets

import androidx.compose.runtime.*
import io.ktor.client.call.*
import io.ktor.client.statement.*
import meineglasfaser.api.routes.PrefetchedEntry
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.withAuth

@Composable
inline fun <reified T> rememberQuery(
    emptyValue: T,
    key1: Any? = null,
    key2: Any? = null,
    key3: Any? = null,
    noinline fetch: suspend () -> Result<HttpResponse>,
): T {
    val queryState = remember { mutableStateOf(emptyValue) }

    LaunchedEffect(key1, key2, key3) {
        queryState.value = fetch().fold(
            onSuccess = { response ->
                response.body<T>()
            },
            onFailure = { error ->
                Toasts.display(
                    Toast.error("Fehler bei Datenabfrage: ${error.message}"),
                )
                console.error("Fehler bei Datenabfrage:", error)
                emptyValue
            }
        )
    }

    return queryState.value
}

@Composable
inline fun <reified T : Any> prefetch(
    resource: T,
    key1: Any? = null,
    key2: Any? = null,
    key3: Any? = null,
): List<PrefetchedEntry> {
    val values = rememberQuery(emptyList<PrefetchedEntry>(), key1, key2, key3) {
        BackendApi.get(resource) {
            withAuth()
        }
    }

    return values
}
